/**
 * One subscription to "something other than looking happened" (`work`
 * frames, `liquid-page-runtime.md` §1's third unsolicited re-read trigger).
 *
 * The server pushes a `work` frame whenever a tool that is not declared
 * `effect: read` finishes or a child turn starts or closes -- `App.tsx` hands every
 * frame here. The frame
 * carries no identity of what ran: a subscribed surface's only answer to it
 * is "read again", so there is nothing else here to hold. Same ten-line
 * publish/subscribe shape as `commandFeed`, with no `resync` of its own --
 * a gap in the stream is `commandFeed.resync()`'s moment, not this one's.
 */

type WorkTick = { session_id: string | null };
type Listener = (tick: WorkTick) => void;
const listeners = new Set<Listener>();

export const workFeed = {
  /** A `work` frame off the stream. */
  publish(tick: WorkTick): void {
    for (const listener of [...listeners]) listener(tick);
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
